import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule as AngularCommonModule } from '@angular/common';
import { CommonModule } from '../common/common.module';
import { DashboardCommonModule } from '../dashboardCommon/dashboardCommon.module';
import { NoveltyMaintenanceComponent } from './components/novelty-maintenance/novelty-maintenance.component';

@NgModule({
  imports: [
    AngularCommonModule,
    CommonModule,
    DashboardCommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule
  ],
  declarations: [NoveltyMaintenanceComponent]
})
export class NoveltiesModule { }
